import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/Dialog";

export default function VirtualBatteryDialog() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          className="mt-5 inline-flex items-center gap-1 text-xs md:text-sm text-gray-400 underline decoration-gray-500 underline-offset-4 transition-colors hover:text-white hover:decoration-white cursor-pointer"
        >
          What&apos;s a virtual battery? →
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto bg-[#181C24] text-white border border-zinc-800 rounded-xl p-6 sm:p-7 shadow-2xl">
        <DialogHeader>
          <DialogTitle className="text-xl sm:text-2xl font-bold text-white tracking-tight">
            What&apos;s a virtual battery?
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm sm:text-base text-gray-300 leading-relaxed pt-3">
          <div>
            <h4 className="font-bold text-white text-base sm:text-lg mb-2">
              Why do people buy batteries for their solar system?
            </h4>
            <p className="text-gray-300">
              Your panels make power during the day — but most of us use the power at night. People then buy big expensive batteries to store the daytime power their roof panels generate, hoping to use it later to reduce night-time energy bills.
            </p>
          </div>

          <div className="bg-brand-orange-500/10 border border-brand-orange-500/30 rounded-lg p-3.5 sm:p-4 text-brand-orange-400 font-medium">
            With SolarCloud, you don&apos;t need a physical battery at all!
          </div>

          <p>
            With <strong>SolarCloud</strong>, your solar credits your energy bill with $$$, which is technically a disbursement from your solar investment. It doesn&apos;t matter if you use energy during the day or night! It will be the new normal for solar ownership - no battery required!
          </p>

          <p className="text-white font-medium">
            No physical battery, no connection cost or maintenance.
          </p>

          <p className="text-brand-orange-400 font-bold">
            Simplify your solar and save with SolarCloud!
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
